import { object, string, number } from 'valibot';

export const userResponseScheme = object({
	detail: string(),
});

export const loginResponseScheme = object({
	access: string(),
});

export const profileResponseScheme = object({
	id: number(),
	username: string(),
	email: string(),
	city_name: string(),
	country: number(),
});
